import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const AnomalyDetectionCard = ({ setFormValues, defaultFormValues }) => {
  const rsrc = useRsrc();
  const [anomalies, setAnomalies] = useState([]);

  const driverLabel = (anomaly) => {
    const parts = [];
    if (anomaly.driverDim1Name) {
      const pct1 = anomaly.driverDim1CoveragePct != null
        ? ` (${Math.round(anomaly.driverDim1CoveragePct * 100)}%)`
        : '';
      parts.push(`${anomaly.driverDim1Name}${pct1}`);
    }
    if (anomaly.driverDim2Name) {
      const pct2 = anomaly.driverDim2CoveragePct != null
        ? ` (${Math.round(anomaly.driverDim2CoveragePct * 100)}%)`
        : '';
      parts.push(`${anomaly.driverDim2Name}${pct2}`);
    }
    return parts.length > 0 ? `Drivers: ${parts.join(' · ')}` : null;
  };

  useEffect(() => {
    rsrc.data('sc', 'MCD_FIN_DASHBOARD_ANOMALIES_DATA_PLUGIN', {}).then(data => {
      setAnomalies(data);
    });
  }, [])

  const handleRowClick = (anomaly) => {
    setFormValues({
      ...defaultFormValues,
      ...anomaly.formValues,
    });
  };

  return (
    <DashboardCard title="Anomaly Detection" icon={far.faSparkles} variant="bold" >
      <Stack spacing={0} divider={<Divider sx={{ my: 0.5 }} />}>
        {anomalies.map((anomaly, index) => {
          const dim2Name = anomaly.dim2Name ? ` + ${anomaly.dim2Name}` : '';
          const drivers = driverLabel(anomaly);
          return (
            <Box key={anomaly.id}>
              <Box
                onClick={() => handleRowClick(anomaly)}
                sx={{
                  cursor: 'pointer',
                  px: 1,
                  py: 1,
                  borderRadius: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
              >
                <Box
                  sx={{
                    minWidth: 20,
                    height: 20,
                    borderRadius: 999,
                    backgroundColor: 'action.selected',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: 1,
                    flexShrink: 0,
                  }}
                >
                  {index + 1}
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {anomaly.dim1Name}{dim2Name}
                  </Typography>
                  <Typography variant="caption" sx={{ lineHeight: 1.3 }}>
                    {anomaly.reasonText}
                  </Typography>
                  {drivers && (
                    <Typography variant="caption" sx={{ lineHeight: 1.3, display: 'block' }}>
                      {drivers}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </DashboardCard>
  );
}